import { makeStyles } from '@material-ui/core/styles';
import logo from '@resources/icons/svg/logo.svg';
import logoVC from '@resources/icons/svg/logoVC.svg';

const useStyles = makeStyles((theme) => ({
  root: {
    width: '25.6rem',
    display: 'flex',
    alignItems: 'center',
    padding: theme.spacing(2, 3),
    boxShadow: '6px 0px 18px rgba(0, 0, 0, 0.06)',
    cursor: 'pointer',
  },
  img: {
    display: 'block',
  },
  imgVC: {
    display: 'flex',
    width: '100%',
  },
  span: {
    fontWeight: 600,
    fontSize: '2rem',
    lineHeight: '2.7rem',
    color: theme.palette.common.grey,
  },
  spanVC: {
    fontWeight: 700,
    fontSize: '2rem',
    textTransform: 'uppercase',
    color: theme.palette.primary.main,
  },
}));

const Logo = ({ onClick }) => {
  const classes = useStyles();

  return (
    <div className={ classes.root } onClick={ onClick }>
      {process.env.REACT_APP_BRAND ? (
        <img className={ classes.imgVC } src={ logoVC } alt="logo" />
      ) : (
        <>
          <img className={ classes.img } src={ logo } alt="logo" />
          <span className={ classes.span }>STUDIO</span>
        </>
      )}
    </div>
  );
};

export default Logo;
